import { Routes, Route } from "react-router-dom";
import LoginForm from "./Components/Auth/login-form.jsx";
import ResetPassword from "./Components/Auth/reset.jsx";
import EnterResetCodePage from "./Components/Auth/EnterResetCodePage";
import LoginCodePage from "./Components/Auth/LoginCodePage";

export default function Welcome() {
  return (
    <Routes>
      <Route path="" element={<LoginForm />} />
      <Route path="login" element={<LoginForm />} />
      <Route path="reset" element={<ResetPassword />} />
      <Route path="reset/enter-code" element={<EnterResetCodePage />} />
      <Route path="login-code" element={<LoginCodePage />} />
    </Routes>
  );
}
